import { useState } from 'react';
import { ScheduleDay } from './types';
import { DEFAULT_SCHEDULE } from './constants';
import { expandSpecialDateRanges } from './specialDates';

export const useSchedule = () => {
  const [schedule, setSchedule] = useState<ScheduleDay[]>(DEFAULT_SCHEDULE);
  const [holidays, setHolidays] = useState<string[]>([]);

  const handleToggleDay = (dayKey: string) => {
    setSchedule((prev) =>
      prev.map((d) => {
        if (d.day !== dayKey) return d;
        const isActive = d.start !== null || d.end !== null;
        return isActive
          ? { ...d, start: null, end: null }
          : { ...d, start: '09:00', end: '18:00' };
      }),
    );
  };

  const handleScheduleChange = (
    dayKey: string,
    field: 'start' | 'end',
    value: string | null,
  ) => {
    setSchedule((prev) =>
      prev.map((d) => (d.day === dayKey ? { ...d, [field]: value } : d)),
    );
  };

  const handleAddHoliday = (date: string) => {
    if (!holidays.includes(date)) {
      setHolidays((prev) => expandSpecialDateRanges([...prev, date], 'local'));
    }
  };

  const handleRemoveHoliday = (date: string) => {
    setHolidays((prev) => prev.filter((d) => d !== date));
  };

  return {
    schedule,
    setSchedule,
    holidays,
    setHolidays,
    handleToggleDay,
    handleScheduleChange,
    handleAddHoliday,
    handleRemoveHoliday,
  };
};
